import { useState } from 'react';

import { captureUtms } from '../utils/url';

const pushUtmsReady = () => {
  const captured = captureUtms();

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'utms_ready',
    ...captured,
  });

  return captured;
};

const UtmProvider = ({ children }) => {
  // captureUtms runs once: reads UTMs from the landing URL,
  // persists to sessionStorage, pushes utms_ready to dataLayer,
  // and returns the object.
  useState(pushUtmsReady);

  return children;
};

export default UtmProvider;
